interface BulkProgressSummaryProps {
  completed: number;
  failed: number;
  pending: number;
  allDone: boolean;
  onRetryFailed: () => void;
  onViewOrders: () => void;
  onBack: () => void;
}

function BulkProgressSummary({
  completed,
  failed,
  pending,
  allDone,
  onRetryFailed,
  onViewOrders,
  onBack,
}: BulkProgressSummaryProps) {
  return (
    <div className="panel">
      <h2>Progress</h2>
      <div style={{ display: 'flex', gap: '24px', marginBottom: '16px' }}>
        <div>
          <span style={{ fontWeight: 600, color: 'var(--success-text)' }}>{completed}</span>
          <span style={{ marginLeft: '4px', color: 'var(--aged-mahogany-light)' }}>Completed</span>
        </div>
        <div>
          <span style={{ fontWeight: 600, color: 'var(--error-text)' }}>{failed}</span>
          <span style={{ marginLeft: '4px', color: 'var(--aged-mahogany-light)' }}>Failed</span>
        </div>
        <div>
          <span style={{ fontWeight: 600 }}>{pending}</span>
          <span style={{ marginLeft: '4px', color: 'var(--aged-mahogany-light)' }}>Pending</span>
        </div>
      </div>

      {allDone && (
        <div style={{ display: 'flex', gap: '12px' }}>
          {failed > 0 && (
            <button className="btn btn-primary" onClick={onRetryFailed}>
              Retry Failed Safely
            </button>
          )}
          <button className="btn btn-primary" onClick={onViewOrders}>
            View Order History
          </button>
          <button className="btn btn-ghost" onClick={onBack}>
            {failed > 0 ? 'Discard Failed & Back' : 'Back to Addresses'}
          </button>
        </div>
      )}
    </div>
  );
}

export default BulkProgressSummary;
